import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'

export function useLanguageSync() {
  const { i18n } = useTranslation()
  const language = useAppPreferencesStore((s) => s.language)

  useEffect(() => {
    let lng: string = 'en'

    if (language === 'pt') lng = 'pt-BR'
    if (language === 'en') lng = 'en'
    if (language === 'ar') lng = 'ar-KW'
    if (language === 'ru') lng = 'ru'

    // Change language only if it differs from the current one
    if (i18n.language !== lng) {
      i18n.changeLanguage(lng)
    }
  }, [language, i18n])
}
